import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("psr_token");
    if (!token) {
      setUser(false);
      setChecking(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data.user))
      .catch(() => {
        localStorage.removeItem("psr_token");
        setUser(false);
      })
      .finally(() => setChecking(false));
  }, []);

  const login = (token, u) => {
    localStorage.setItem("psr_token", token);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("psr_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, checking, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
